"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgMobileAlt = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M11.977 20.96a2.016 2.016 0 100-4.03 2.016 2.016 0 000 4.03z" }),
        react_1.default.createElement("path", { fill: "currentColor", d: "M15.945.04H8.008a3.981 3.981 0 00-3.985 3.983v15.954a3.981 3.981 0 003.985 3.984h7.984a3.981 3.981 0 003.985-3.984V4.023C19.93 1.82 18.148.04 15.945.04zM5.992 4.022c0-1.078.89-2.015 2.016-2.015h7.984c1.078 0 2.016.89 2.016 2.015v9.954H5.992V4.023zm9.953 17.922H8.008c-1.078 0-2.016-.89-2.016-2.015v-3.985h11.969v3.985a2 2 0 01-2.016 2.015z" })));
};
exports.default = SvgMobileAlt;
//# sourceMappingURL=MobileAlt.js.map